import styled from 'styled-components';
import colors from 'Styles/colors';
import StandardTextField from 'Common/Components/StandardTextField';
import { ReactComponent as Refresh } from 'Images/reload.svg';
import { ReactComponent as Help } from 'Images/noun-help.svg';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.backgrounds.detailModalFields};
  display: flex;
  flex-direction: column;
  padding: 0px 20px 20px 20px;
  & > :first-child {
    margin-bottom: 17px;
  }
`;
Wrapper.displayName = 'Wrapper';

export const Table = styled.table`
`;
Table.displayName = 'Table';

export const TableBody = styled.tbody`
  & > :first-child td {
    padding-bottom: 12px;
  }
  & > :not(:first-child):not(:last-child) td {
    padding-bottom: 7px;
  }
`;
TableBody.displayName = 'TableBody';

export const Text = styled.td`
  font-size: 12.5px;
  color: #1c4566;
`;
Text.displayName = 'Text';

export const Title = styled.td`
  font-weight: 600;
  font-size: 16px;
  padding-bottom: 10px;
  color: #1c4566;
`;

export const Line = styled.tr`
  font-size: 13px;
  & >:first-child {
    width: 180px;
  }
`;
Line.displayName = 'Line';

export const Link = styled.a`
  font-weight: normal;
  font-size: 13.5px;
  color: #1c4566;
`;

export const IconButton = styled.div`
  cursor: pointer;
`;
IconButton.displayName = 'IconButton';

export const RefreshIcon = styled(Refresh)`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  g {
    fill: ${colors.darkBlueGrey};
  }
`;
RefreshIcon.displayName = 'RefreshIcon';

export const HelpIcon = styled(Help)`
  width: 18px;
  height: 18px;
`;
HelpIcon.displayName = 'HelpIcon';

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 calc(50% - 11px);
  min-width: 0;
`;
Field.displayName = 'Field';

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px 21px;

  & + &,
  & + ${Field},
  ${Field} + & {
    margin-top: 12px;
  }
`;
Row.displayName = 'Row';

export const Label = styled.label`
  font-weight: 400;
  font-size: 12.5px;
  color: ${colors.grey17};
  margin-bottom: 8px;
`;
Label.displayName = 'Label';

export const SummaryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
SummaryList.displayName = 'SummaryList';

export const SummaryItem = styled.div`
  display: flex;
  align-items: baseline;
`;
SummaryItem.displayName = 'SummaryItem';

export const SummaryLabel = styled.div`
  flex: 0 0 145px;
  color: ${({ theme }) => theme.text.detailModalFields};
  font-size: 16px;
  font-weight: 600;
`;
SummaryLabel.displayName = 'SummaryLabel';

export const SummaryValue = styled.div`
  min-width: 0;
  color: ${({ theme }) => theme.text.detailModalFields};
  font-size: 16px;
  font-weight: 500;
  overflow-wrap: anywhere;
`;
SummaryValue.displayName = 'SummaryValue';

export const FixField = styled.div`
  min-height: 34px;
  padding: 7px 10px 7px 15.5px;
  background-color: ${({ theme }) => theme.textfield.background};
  font-size: 14.5px;
  color: ${({ theme }) => theme.textfield.text};
  line-height: 1.4;
  overflow-wrap: anywhere;
  white-space: normal;
`;
FixField.displayName = 'FixField';

export const ServicesTableWrapper = styled.div`
  margin-top: 18px;
  margin-bottom: 22px;
`;
ServicesTableWrapper.displayName = 'ServicesTableWrapper';

export const ServicesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: ${({ theme }) => theme.textfield.text};

  tbody tr:nth-child(even) {
    background-color: ${({ theme }) => theme.textfield.background};
  }
`;
ServicesTable.displayName = 'ServicesTable';

export const ServicesHeader = styled.th`
  padding: 9px 10px;
  border-top: 1px solid ${({ theme }) => theme.textfield.shadow};
  border-bottom: 1px solid ${({ theme }) => theme.textfield.shadow};
  text-align: left;
  font-size: 12.5px;
  font-weight: 600;
  color: ${colors.grey17};
`;
ServicesHeader.displayName = 'ServicesHeader';

export const ServicesCell = styled.td`
  padding: 8px 10px;
  font-size: 13.5px;
  overflow-wrap: anywhere;
`;
ServicesCell.displayName = 'ServicesCell';

export const TextField = styled(StandardTextField)`
  color: ${colors.grey17};
  font-weight: 400;
  font-size: 12.5px;
  margin-bottom: 0;
  display: block;
  width: ${(props) => (props.width ? props.width : '100%')};
  
  span {
    font-weight: 400;
    margin-bottom: 0;
  }

  input {
    margin-top: 6px;
    background-color: ${({ theme }) => theme.textfield.background};
    color: ${({ theme }) => theme.textfield.text};
    box-shadow: ${({ error }) => error ? 'inset 0 -1px 0 0 #ea3158' : 'none'};

    &::placeholder {
      color: ${({ theme }) => theme.text.placeholder};
      opacity: 0.8;
    }

    ${({ disabled }) =>
    disabled
      ? `
          cursor: not-allowed;
        `
      : ''}
  }

  svg {
    top: 34px;
  }
`;
TextField.displayName = 'TextField';
